import React from 'react';
import Grid from "@mui/material/Grid";
import {
    CANCELLATION_POLICIES_REGISTRY,
    TOURIST_TAX_POLICIES_REGISTRY
}
from "../../../services/booking_conditions/enums";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem";
import {DatePicker, TimePicker} from "@mui/x-date-pickers";
import {startOfDay} from "date-fns";
import Typography from "@mui/material/Typography";
import {isValidDateObject} from "../../../services/date/validators";


const StepBookingCondition = ({formik, bookingConditionUtils}) => {
    const filedProps = ({name, onChange}) => ({
        name: `bookingCondition.${name}`,
        value: formik.values.bookingCondition[name] ?? '',
        error: Boolean(formik.touched.bookingCondition?.[name]) && Boolean(formik.errors.bookingCondition?.[name]),
        helperText: formik.touched.bookingCondition?.[name] && formik.errors.bookingCondition?.[name],
        onChange: onChange ?? formik.handleChange,
        fullWidth: true
    })

    const timePickerProps = ({name}) => ({
        name: `bookingCondition.${name}`,
        onChange: (time) => formik.setFieldValue(`bookingCondition.${name}`, isValidDateObject(time) ? time : null),
        value: formik.values.bookingCondition[name],
        minutesStep: 15,
        slotProps: {
            textField: {
                fullWidth: true,
                error: Boolean(formik.touched.bookingCondition?.[name]) && Boolean(formik.errors.bookingCondition?.[name]),
                helperText: formik.touched.bookingCondition?.[name] && formik.errors.bookingCondition?.[name],
            }
        }
    });

    const handleCancellationPolicyChange = bookingConditionUtils.cancellationPolicyChangeHandler(formik);
    const handleTouristTaxPolicyChange = bookingConditionUtils.touristTaxPolicyChangeHandler(formik);

    const touristTaxUnitPriceDisabled = bookingConditionUtils.touristTaxUnitPriceDisabled(formik.values.bookingCondition.touristTaxPolicy);
    const disabledRefundableUntil = bookingConditionUtils.refundableUntilDisabled(formik.values.bookingCondition.cancellationPolicy);

    const cancellationPolicyDescription = CANCELLATION_POLICIES_REGISTRY.find(policy => policy.value === formik.values.bookingCondition.cancellationPolicy)?.getDescription({
        refundableUntil: formik.values.bookingCondition.refundableUntil
    }) || '';

    const touristTaxPolicyDescription = TOURIST_TAX_POLICIES_REGISTRY.find(policy => policy.value === formik.values.bookingCondition.touristTaxPolicy)?.getDescription({
        touristTaxUnitPrice: formik.values.bookingCondition.touristTaxUnitPrice
    }) || '';

    return <>
        <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 2}}>
            Cancellazione e Tassa di soggiorno
        </Typography>
        <Grid container columnSpacing={3}>
            <Grid item xs={12} md={6} sx={{mt: 3}}>
                <SelectField options={CANCELLATION_POLICIES_REGISTRY}
                             label="Politica di cancellazione"
                             {...filedProps({name: 'cancellationPolicy', onChange: handleCancellationPolicyChange})} />
            </Grid>
            <Grid item xs={12} md={6} sx={{mt: 3}}>
                <DatePicker value={formik.values.bookingCondition.refundableUntil}
                            onChange={date => formik.setFieldValue("bookingCondition.refundableUntil", startOfDay(date))}
                            defaultCalendarMonth={isValidDateObject(formik.values.bookingCondition.refundableUntil) ? formik.values.bookingCondition.refundableUntil : undefined}
                            label="Rimborsabile fino alla data"
                            closeOnSelect
                            disableHighlightToday
                            showDaysOutsideCurrentMonth
                            disablePast
                            disabled={disabledRefundableUntil}
                            maxDate={formik.values.arrival}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    error: Boolean(formik.touched.bookingCondition?.refundableUntil) && Boolean(formik.errors.bookingCondition?.refundableUntil),
                                    helperText: formik.touched.bookingCondition?.refundableUntil && formik.errors.bookingCondition?.refundableUntil
                                }
                            }}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant='caption' color='textPrimary' fontWeight="light">
                    {cancellationPolicyDescription}
                </Typography>
            </Grid>
            <Grid item xs={12} md={6} sx={{mt: 3}}>
                <SelectField options={TOURIST_TAX_POLICIES_REGISTRY}
                             label="Politica di tassa di soggiorno"
                             {...filedProps({
                                 name: 'touristTaxPolicy',
                                 onChange: handleTouristTaxPolicyChange
                             })} />
            </Grid>
            <Grid item xs={12} md={6} sx={{mt: 3}}>
                <TextField label="Prezzo unitario tassa di soggiorno"
                           type="number"
                           disabled={touristTaxUnitPriceDisabled}
                           {...filedProps({name: 'touristTaxUnitPrice'})} />
            </Grid>
            <Grid item xs={12}>
                <Typography variant='caption' color='textPrimary' fontWeight="light">
                    {touristTaxPolicyDescription}
                </Typography>
            </Grid>
        </Grid>
        <Typography variant='h6' color='primary' fontWeight="normal" sx={{mt: 2, mb: 2}}>
            Orari Check-In e Check-Out
        </Typography>
        <Grid container spacing={3}>
            <Grid item xs={12} md={6} >
                <TimePicker label="Check-In dalle" {...timePickerProps({name: 'checkInFrom'})}/>
            </Grid>
            <Grid item xs={12} md={6}>
                <TimePicker label="Check-Out entro" {...timePickerProps({name: 'checkOutBefore'})}/>
            </Grid>
        </Grid>
    </>
}


const SelectField = ({options, ...props}) => {
    const {value, ...rest} = props;

    return <TextField select value={value} {...rest}>
        {
            options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))
        }
    </TextField>
}

export default StepBookingCondition;